// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","loader__main":"Loader_loader__main__ee966"};